import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, CTA_LABEL } from '../data/checkout';
import { trackCheckout } from '../utils/tracking';
const highlights = ['6 volumi completi', '5 Bonus Strategici', 'Accesso immediato'];
export function Hero() {
  return <section className="relative pt-8 sm:pt-14 pb-12 px-4 overflow-hidden" data-id="element-139" data-mp="4jm4pkalevoz">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gold-dark/20 via-black to-black -z-10" data-id="element-140" data-mp="1285x3nzc5smb" />

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-141" data-mp="sbb57nxkiqh0">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-142" data-mp="sd4aaysj92mw">
          <p className="inline-block px-3 py-1 rounded-full border border-gold/30 bg-gold/10 text-gold-light font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-143" data-mp="382fedm0930dv">
            📚 Metodologia della Ricerca Pro
          </p>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6" data-id="element-144" data-mp="3o6ar1z0hed1j">
            Tutto il tuo anno di Metodologia della Ricerca{' '}
            <span className="text-gold-gradient" data-id="element-145" data-mp="3e8efj63mtg2w">risolto in un pomeriggio.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-[280px] sm:max-w-md md:max-w-2xl mb-4 sm:mb-6" data-id="element-146" data-mp="30h9eq0oj2hqz">
          <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-147" data-mp="2vjpxqt0g3qvc" />
          <img src="https://cdn.magicpatterns.com/uploads/nZNCL338h25eHBWJEvgoNY/Diseno_sin_titulo_(63).png" alt="Metodologia della Ricerca Pro: 6 volumi completi, 5 bonus e materiali didattici pronti all’uso" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-148" data-mp="2hix2g62bkrr6" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-149" data-mp="na094yrvn3e6">
          <p className="text-sm sm:text-lg md:text-xl text-gray-300 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-150" data-mp="dbar95zzdixx">
            Il sistema completo per pianificare, insegnare e valutare — pronto
            da usare da oggi.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-151" data-mp="111yd6v6qe93h">
            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-152" data-mp="114kjkrhvyik4">
              {CTA_LABEL}
            </Button>
          </div>

          <ul className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-400" data-id="element-153" data-mp="1x9b42xkwqvaz">
            {highlights.map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-154" data-mp="21bpmxhoktv29">
                <CheckCircleIcon size={14} className="text-gold" aria-hidden="true" data-id="element-155" data-mp="269hdo8dhjb4v" />
                <span data-id="element-156" data-mp="2b0pq7da43cm9">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}